"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localize = void 0;
window.TYPO3.lang = window.TYPO3.lang || {};
function localize(key, fallback) {
    if (!window.TYPO3.lang[key]) {
        return fallback;
    }
    return window.TYPO3.lang[key];
}
exports.Localize = localize;
